import React from "react";

export const GoogleIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.4399 11.715H24.5002V11.6666H14.0002V16.3333H20.5936C19.6317 19.0498 17.0469 20.9999 14.0002 20.9999C10.1344 20.9999 7.00016 17.8657 7.00016 13.9999C7.00016 10.1342 10.1344 6.99992 14.0002 6.99992C15.7846 6.99992 17.408 7.67309 18.6441 8.77267L21.944 5.47275C19.8603 3.53084 17.0732 2.33325 14.0002 2.33325C7.55725 2.33325 2.3335 7.557 2.3335 13.9999C2.3335 20.4428 7.55725 25.6666 14.0002 25.6666C20.4431 25.6666 25.6668 20.4428 25.6668 13.9999C25.6668 13.2177 25.5863 12.4541 25.4399 11.715Z"
        fill="#FFC107"
      />
      <path
        d="M3.67871 8.56967L7.51179 11.3808C8.54896 8.81292 11.0608 6.99992 14.0002 6.99992C15.7846 6.99992 17.408 7.67308 18.6441 8.77267L21.944 5.47275C19.8604 3.53084 17.0732 2.33325 14.0002 2.33325C9.51904 2.33325 5.63288 4.86317 3.67871 8.56967Z"
        fill="#FF3D00"
      />
      <path
        d="M14 25.6666C17.0135 25.6666 19.7517 24.5133 21.8219 22.6379L18.2111 19.5824C17.0004 20.5031 15.521 21.0011 14 20.9999C10.9655 20.9999 8.38894 19.065 7.41827 16.3647L3.61377 19.296C5.5446 23.0742 9.46577 25.6666 14 25.6666Z"
        fill="#4CAF50"
      />
      <path
        d="M25.4398 11.7152H24.5V11.6667H14V16.3334H20.5934C20.1333 17.6263 19.3045 18.7561 18.2093 19.5832L18.2111 19.582L21.8219 22.6375C21.5664 22.8697 25.6667 19.8334 25.6667 14.0001C25.6667 13.2178 25.5862 12.4542 25.4398 11.7152Z"
        fill="#1976D2"
      />
    </svg>
  );
};
